import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {FORM_TYPE, formTypeOptions} from '../../Config/appConfig';
import CommonForm from './CommonForm';

interface CommonFormControllerProps {
    formType: string,
}

interface CommonFormControllerState {
    refNo: string,
    formType: string
}

class CommonFormController extends React.Component <RouteComponentProps & CommonFormControllerProps, CommonFormControllerState> {
    public constructor(props: CommonFormControllerProps) {
        super(props);
        this.state = {
            refNo: '',
            formType: this.props.formType
        }
    }

    public componentWillMount() {
        const path = this.props.history.location.pathname.split('/');
        this.setState({
            refNo: path[path.length-1]
        });
    }

    public componentDidMount() {
        this.setFormType(this.props.formType);
    }


    public setFormType(formType: string) {
        this.setState({
            formType
        });
    }

    public changeRefNo(refNo: string) {
        this.setState({
            refNo
        });
    }

    public changeFormType(type: string) {
        let formType = '';
        switch (type) {
            case formTypeOptions[0].value:
                formType = FORM_TYPE.IN_CREATE_COVER_NOTE;
                break;
            case formTypeOptions[1].value:
                formType = FORM_TYPE.IN_CREATE_POLICY;
                break;
            default:
                formType = type;
                break;
        }
        this.setState({
            formType
        });
    }

    public render() {
        return (
            <CommonForm
                refNo={this.state.refNo}
                changeRefNo={(refNo) => this.changeRefNo(refNo)}
                formType={this.state.formType}
                changeFormType={(formType) => this.changeFormType(formType)}/>
        );
    }
}

export default withRouter(CommonFormController);



// WEBPACK FOOTER //
// ./src/Components/Form/CommonFormController.tsx